import React, {useState, useEffect} from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import {  Modal, ModalHeader, ModalBody, ModalFooter, CardImg, CardText, CardBody,CardHeader,
    CardTitle, CardSubtitle  } from "reactstrap";
import puri from "../../../images/sb-images/puri.webp";
import fruit from "../../../images/sb-images/fruit.webp";
import Pagination from 'react-js-pagination';
import Loader from "../Loader";
import "./cancellationStatus.css";
import axios from "axios";
import { var_api } from "../../constant";
import { useHistory } from "react-router-dom";

const CancellationStatus = () => {
  const history = useHistory();
    const [isOpen, setIsOpen] = useState(false);
    const [isLogin, setIsLogin] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15; 
     const [totalItems, setTotalItems] = useState(0);
    const [startIndex, setStartIndex] = useState(0);
    const [ searchQuery,setSearchQuery] = useState('');
    const [cancelHistory, setcancelHistory] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');


    const handleToOpenView = (record) => {
      setSelectedCustomer(record);
        setIsOpen(true);
    }

    useEffect(() => {
      const now = new Date();
    const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDayOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);

    const formattedFromDate = formatDate(firstDayOfMonth);
    const formattedToDate = formatDate(lastDayOfMonth);

    setFromDate(formattedFromDate);
    setToDate(formattedToDate);

    //fetchcancelhistory(formattedFromDate, formattedToDate);
  }, []);

  useEffect(() => {
    if (fromDate && toDate) {
      fetchcancelhistory(fromDate, toDate);
    }
  }, [fromDate, toDate,currentPage]);
  
  const formatDate = (date) => {
    const d = new Date(date);
    let day = '' + d.getDate();
    let month = '' + (d.getMonth() + 1);
    const year = d.getFullYear();
  
    if (day.length < 2) day = '0' + day;
    if (month.length < 2) month = '0' + month;
  
    return [day, month, year].join('-');
  };

    const toggle = () => setIsOpen(!isOpen);

    const fetchcancelhistory = async (fromDate, toDate) => {
      const token = localStorage.getItem('token');
      const startIndexCalc = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndexCalc + itemsPerPage;
      setIsLogin(true);
      try {
          const response = await axios.get(`${var_api}/api/cancellation-history/get/${fromDate}/${toDate}`, {
              headers: {
                  'Authorization': `${token}`
              }
          });
          const cancelhistory = response.data;
          // setEmployee(response.data);
          if (cancelhistory.length > 0) {
            setcancelHistory(cancelhistory.slice(startIndexCalc, endIndex));
              setTotalItems(cancelhistory.length);
              setStartIndex(startIndexCalc); // Update startIndex state variable
          } else {
              console.log('No data found.');
              setcancelHistory([]);
              setTotalItems(0);
              setStartIndex(0); // Reset startIndex state variable
          }
          setIsLogin(false);
      } catch (error) {
        setIsLogin(false);
          if (error.response && error.response.status === 401) {
              history.push('/signin');
          }
      }
  };
  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value)
    };
    const filteredCancelHistory = Array.isArray(cancelHistory) && cancelHistory.filter((order)=> {
      const searchLower = searchQuery.toLowerCase();
      return(
          (order.customer_name && order.customer_name.toString().toLowerCase().includes(searchLower)) ||
          (order.date && order.date.toString().toLowerCase().includes(searchLower)) ||
          (order.customer_mobile && order.customer_mobile.toString().toLowerCase().includes(searchLower)) ||
          (order.employee_name && order.employee_name.toString().toLowerCase().includes(searchLower)) ||
          (order.remarks && order.remarks.toString().toLowerCase().includes(searchLower))
      )
  });
  // const filteredCancelHistory = cancelHistory.filter((record) =>
  //   record.customer_name.toLowerCase().includes(searchQuery.toLowerCase())
  // );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
};


 // Function to convert minutes to hours and minutes
 const convertMinutesToHours = (minutes) => {
  if (!minutes && minutes == 0) return "0h 0m"; 
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0) {
    return `${hours} hrs ${remainingMinutes} mins`;
  } else {
    return `${remainingMinutes} mins`;
  }
};

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       Cancellation History
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <div className="d-flex justify-content-center">
      <div className="card" style={{ width: "auto", margin: "0px", height: "auto", borderRadius: "10px" }}>
        <div className="card-body">
          <div className="row">
            <div className="col">
              <label style={{ color: "rgba(103, 120, 95)" }}>From Date:</label>
              <input 
                type="date" 
                placeholder="From time" 
                value={fromDate.split('-').reverse().join('-')}
                onChange={(e) => setFromDate(e.target.value.split('-').reverse().join('-'))}
              />
            </div>
            <div className="col">
              <label style={{ color: "rgba(103, 120, 95)" }}>To Date:</label><br />
              <input 
                type="date" 
                placeholder="To time" 
                value={toDate.split('-').reverse().join('-')}
                onChange={(e) => setToDate(e.target.value.split('-').reverse().join('-'))}
              />
            </div>
          </div>
        </div>
      </div>
      <br/>
    <br/>
    </div>
    
                <Col xs={12} md={12} lg={12} xl={12} xxl={12} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"auto", padding:"20px", marginTop:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}><span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  
                 
        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Date</th>
              <th>Cust.Name</th>
              <th>Mobile</th>
              <th>Employee</th>
              <th>Remarks</th>
              <th>View Details</th>
            </tr>
          </thead>
          <tbody>
          {filteredCancelHistory.length > 0 ? (
            filteredCancelHistory.map((record, index) => (
          <tr key={record.order_id}>
            <td>{startIndex+index + 1}</td>
            <td>{record.date}</td>
            <td>{record.customer_name}</td>
            <td>{record.customer_mobile}</td>
            <td>{record.employee_name}</td>
            <td>{record.remarks}</td>
            <td>
              <Button variant="primary" className="m-1" onClick={() => handleToOpenView(record)}>
                <i className="bi bi-eye-fill"></i>
              </Button>
            </td>
          </tr>
        ))
      ): (
          <tr>
            <td colSpan="8" className="text-center">No data available</td>
          </tr>
        )}
            </tbody>
        </Table>
        <br/>
        <Pagination
    activePage={currentPage}
    itemsCountPerPage={itemsPerPage}
    totalItemsCount={totalItems} // Update to reflect total items for pagination
    pageRangeDisplayed={5}
    onChange={handlePageChange}
    itemClass="page-item"
    linkClass="page-link"
    innerClass="pagination justify-content-end"
    activeClass="active-pagination" // Custom class for the active pagination item
/>
      </Card>
                </Col>
               
            </Row>
        </div>

        {selectedCustomer && (
        <Modal isOpen={isOpen} toggle={toggle} size="md">
      <ModalHeader toggle={toggle} style={{ backgroundColor: "rgba(50, 103, 19, 0.305)" }}>Cancellation Details</ModalHeader>
      <ModalBody>
        <div className="p-5">
          <div style={{ maxWidth: "500px", margin: "auto" }}>
            <h6><b style={{ color: "rgba(103, 120, 95)" }}>Date:</b> {selectedCustomer.date} <span style={{ float: "right" }}><b style={{ color: "rgba(103, 120, 95)" }}>Time</b>: 11:00 AM</span></h6>
            <h6><b style={{ color: "rgba(103, 120, 95)" }}>Customer:</b> {selectedCustomer.customer_name}<span style={{ float: "right" }}><b style={{ color: "rgba(103, 120, 95)" }}>Mobile</b>: {selectedCustomer.customer_mobile}</span></h6>
            <h6><b style={{ color: "rgba(103, 120, 95)" }}>Service count :</b> {selectedCustomer.services.length}<span style={{ float: "right" }}><b style={{ color: "rgba(103, 120, 95)" }}>Employee</b>: {selectedCustomer.employee_name}</span></h6>
            <h6><b style={{ color: "rgba(103, 120, 95)" }}>Remarks</b>: {selectedCustomer.remarks}</h6>
          </div>
          <br />
          <div className="d-flex justify-content-center">
            <div style={{ maxHeight: "400px", marginTop: "25px", margin: "auto" }}>
              {selectedCustomer.services.map((service, index) => (
                <Card bg="light" key={index} text="dark" style={{ maxWidth: "22rem", height: "auto", border: "none", borderBottom: "1px solid black", borderRadius: "0px", marginTop: "10px" }} className="mb-2">
                  <div className="row g-0">
                    <div className="col-md-4 p-3">
                      {/* Assuming you have the image URL */}
                      <CardImg src={`${var_api}/${service.service_image}`} alt="Service image" style={{ borderRadius: "50px" }} />
                    </div>
                    <div className="col-md-8">
                      <CardBody>
                        <CardText>
                          <h6 className="fw-bold">{service.service_name}</h6>
                          <h6>{convertMinutesToHours(service.service_duration)}</h6>
                          <h6 className="fw-bolder">{service.service_price} $</h6>
                          <h6>Start Time:{" "}
                            {service.room_start_time || service.seat_start_time? service.room_start_time || service.seat_start_time: "-"}
                          </h6>
                          <h6> End Time:{" "}
                            {service.room_end_time || service.seat_end_time? service.room_end_time || service.seat_end_time: "-"}
                          </h6>
                        </CardText>
                      </CardBody>
                    </div>
                  </div>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="danger" onClick={toggle}>Close</Button>
      </ModalFooter>
    </Modal>)}
        </>
    )
}

export default CancellationStatus;